import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { ManagerCount } from '../types/insights'

export function usePacketsByManager(year?: string, limit?: number) {
  return useQuery({
    queryKey: ['insights', 'packets-by-manager', year, limit],
    queryFn: async () => {
      const params: Record<string, string> = {}
      if (year) params.year = year
      if (limit) params.limit = limit?.toString() || ''
      const response = await get<{ data: ManagerCount[] }>('/insights/packets-by-manager', params)
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
  })
} 